import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import VueJsonp from 'vue-jsonp'
import common from './models/common.js'
import Regex from './models/Regex.js'
import Meta from 'vue-meta'
	
// 自定义组件
import ZoomlaFoot from './components/ZoomlaFoot.vue'
	
// import hljs from 'highlight.js/lib/highlight.js'


// 自定义引用
import "zico/css/zico.min.css";
import 'highlight.js/styles/github.css';
import  'highlightjs-line-numbers.js/src/highlightjs-line-numbers.js';
// import "./assets/js/highlightjs-line-numbers.js";


Vue.config.productionTip = false
Vue.component('ZoomlaFoot', ZoomlaFoot)
Vue.use(VueJsonp)
Vue.use(common)
Vue.use(Regex)
Vue.use(Meta)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')


/*
Vue.component('remote-script', {
    render: function (createElement) {
        var self = this;
        return createElement('script', {
            attrs: {
                type: 'text/javascript',
                src: this.src
            },
            on: {
                load: function (event) {
                    self.$emit('load', event);
                },
                error: function (event) {
                    self.$emit('error', event);
                },
                readystatechange: function (event) {
                    if (this.readyState == 'complete') {
                        self.$emit('load', event);
                    }
                }
            }
        });
    },
    props: {
        src: {
            type: String,
            required: true
        }
    }
});

引用上面的一段,然后在.vue页用下面方法可以引用外部JS
<remote-script src=""></remote-script>
*/